module.exports = __webpack_public_path__ + "img/uz_img1.be12a1f2.png";